
export default function WhatHappensNext() {
  return (
    <section className="py-16 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          What Happens After You Submit
        </h2>
        <div className="space-y-4">
          <div className="flex items-start gap-4">
            <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
            <p className="text-gray-700 text-base">
              I review your website and current contact process
            </p>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
            <p className="text-gray-700 text-base">
              I outline how responses and follow-ups would work
            </p>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 flex-shrink-0"></div>
            <p className="text-gray-700 text-base">
              I show you a simple plan tailored to your business
            </p>
          </div>
        </div>
        <p className="text-center text-gray-600 mt-8 font-medium">
          No pressure — just a clear explanation.
        </p>
      </div>
    </section>
  );
}